import { Grid, Box } from '@chakra-ui/react'
import { FC, useEffect, useMemo } from 'react'

import useParametrizationConfigPurchase from '@hook/parametrization/use-config-purchase'
import useAuth from '@hook/shared/use-auth'
import useFilters from '@hook/shared/use-filters'
import useLayout from '@hook/shared/use-layout'
import useSessions from '@hook/shared/use-sessions'

import LayoutEmpty from '@component/Layout/Empty'
import LayoutFilters from '@component/Layout/Filters'
import LayoutLoader from '@component/Layout/Loader'
import TableGrid from '@component/Layout/TableGrid'
import GridQuantity from '@component/Layout/TableGrid/GridQuantity'
import LayoutTools from '@component/Layout/Tools'
import SelectedTableBarReabCronPurchaseUser from '@component/Parameterization/cronPurchase/User/SelectedTableBarUser'

import cronPurchaseUser from '@base/variables/headers/cronograma-purchase/cron-purchase-user'

const PurchaseCronUserConfig: FC = () => {
  const { menuToggle } = useLayout()
  const { getFilters } = useFilters()
  const {
    loading,
    pagination,
    filters,
    setFilters,
    fetching,
    query,
    tableInteractionUser,
    companieId,
    actionsUser,
    getDataUsers,
    dataUser,
    loadingUser,
    setFilename,
    setQuery,
    filtersList,
    params,
    handleUpdateParams,
    clearAllFilters
  } = useParametrizationConfigPurchase()

  const { companies: authCompanies } = useAuth()
  const { hasSessions } = useSessions()

  const tableHeight = useMemo(
    () =>
      menuToggle
        ? hasSessions
          ? 'calc(100vh - 225px)'
          : 'calc(100vh - 193px)'
        : hasSessions
        ? 'calc(100vh - 366px)'
        : 'calc(100vh - 334px)',
    [menuToggle, hasSessions]
  )

  const shouldShowSelectedTableBar =
    authCompanies?.length === 0 ||
    (authCompanies?.length > 1 && companieId === '') ||
    loadingUser

  // Os dados da aba são buscados pelo PurchaseConfig (uma busca por aba ativa)
  useEffect(() => {
    getFilters({
      companies: true,
      centers: true,
      providersForPurchase: true,
      compactCategories: true,
      compradores: true
    })
  }, [getFilters])

  return (
    <Grid
      bg="white"
      templateColumns={!filters ? '90vw' : '260px calc(100vw - 280px)'}
    >
      {filters && (
        <LayoutFilters
          filters={filtersList}
          values={params}
          onChange={handleUpdateParams}
          loading={loading}
          canCancel={fetching}
          onFilter={() => (companieId ? getDataUsers(companieId, true) : null)}
          onClearAllFilters={clearAllFilters}
          heightAll={'80vh'}
        />
      )}

      <Box>
        <LayoutTools
          title={'Cronograma Compra - Compradores'}
          filters={filters}
          actions={actionsUser}
          query={query}
          onSearchChange={setQuery}
          onTitleChange={setFilename}
          toggleFilters={setFilters.toggle}
          isDisabled={loading || fetching || dataUser.length === 0}
        />

        {/* Mostra a barra somente quando houver empresa válida e selecionada */}
        {!shouldShowSelectedTableBar && (
          <SelectedTableBarReabCronPurchaseUser />
        )}

        {loadingUser ? (
          <LayoutLoader
            title="Recuperando informações..."
            message="Aguarde enquanto buscamos os dados no banco de dados"
          />
        ) : authCompanies?.length === 0 ? (
          <LayoutEmpty
            type="chartEmpty"
            title="É necessário pelo menos 1 empresa cadastrada no perfil"
            message=""
          />
        ) : authCompanies?.length > 1 && companieId === '' ? (
          <LayoutEmpty
            type="chartEmpty"
            title="Selecione ao menos 1 empresa"
            message="Filtre sua busca em cima para obter informações"
          />
        ) : dataUser.length === 0 ? (
          <LayoutEmpty
            title="Nada encontrado!"
            message="Filtre sua busca ao lado para obter informações"
          />
        ) : (
          <Box>
            <Box paddingLeft={2}>
              <GridQuantity data={dataUser} pagination={null} />
            </Box>

            <TableGrid
              id="cron-purchase-user"
              entity="cron-purchase-user"
              headers={cronPurchaseUser}
              query={query}
              data={dataUser}
              itsSortable={true}
              loading={fetching}
              actions={tableInteractionUser}
              height={tableHeight}
              pagination={pagination}
            />
          </Box>
        )}
      </Box>
    </Grid>
  )
}

export default PurchaseCronUserConfig
